import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import * as fromCheckoutReducer from '@pages/checkout-app/checkout-store/reducers/checkout.reducer';
import { CheckoutActions } from '@pages/checkout-app/checkout-store/actions';
import { takeUntil } from 'rxjs/operators';
import { ofType, Actions } from '@ngrx/effects';
import { ExtensionsService } from '@pages/checkout-app/services/extensions/extensions.service';
import { onDestroyComplete } from '@app/sharedModule/decorators/on-destroy-unsubscribe.decorator';
import { Subject } from 'rxjs';
import { ToastOptions } from '@app/storybook/services/toast/toast-types';

@Component({
  selector: 'delete-extension-dialog',
  templateUrl: './delete-extension-dialog.html',
  styleUrls: ['./delete-extension-dialog.scss'],
  standalone: false,
})
export class DeleteExtensionDialog implements OnInit, OnDestroy {
  @onDestroyComplete() destroy$ = new Subject();
  isLoading$ = this.store.select(fromCheckoutReducer.selectIsLoading);
  extensionId: number;
  constructor(
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private store: Store<fromCheckoutReducer.State>,
    private actions$: Actions,
    private extensionsService: ExtensionsService,
  ) {}

  ngOnDestroy() {}

  ngOnInit() {
    this.extensionId = this.data.extensionId;
    this.detectDeleteAction();
  }

  detectDeleteAction() {
    this.actions$.pipe(takeUntil(this.destroy$), ofType(CheckoutActions.deleteExtensionSuccess)).subscribe(() => {
      const options: ToastOptions = { message: 'Extension deleted successfully', mode: 'info' };
      this.extensionsService.createToast(options);
      this.dialogRef.close();
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onDeleteExtension() {
    this.store.dispatch(CheckoutActions.deleteExtension({ extensionId: this.extensionId }));
  }
}
